import Loader from './Loader'

export default Loader



// WEBPACK FOOTER //
// ./src/components/Layout/Loader/index.js